import { object, number, string, preprocess } from 'zod';

import { makeZodValidate as makeValidate } from '@occc/ui-forms';
import { IS_REQUIRED, IS_VALID } from '@occc-app/lib/constants/validationMessages';
import { validatePhoneNumber } from '@occc/utils-phone-number';

const PERFORMANCE_GOAL_MIN_LIMIT = 1;

const monthlyPerformanceGoalSchema = number({ required_error: IS_REQUIRED })
  .int('Must be an integer')
  .min(
    PERFORMANCE_GOAL_MIN_LIMIT,
    `This field should be greater than ${PERFORMANCE_GOAL_MIN_LIMIT}`,
  );

export const retailerNetworkConfigurationSchema = object({
  name: string({ required_error: IS_REQUIRED }),
  displayName: string({ required_error: IS_REQUIRED }),
  customerId: object({}, { required_error: IS_REQUIRED }),
  adminName: string({ required_error: IS_REQUIRED }),
  address: object({
    street1: string({ required_error: IS_REQUIRED }),
    city: string({ required_error: IS_REQUIRED }),
    state: object({}, { message: IS_REQUIRED }),
    zipCode: string({ required_error: IS_REQUIRED }).regex(
      /^[0-9]{5}$/,
      'Zip code must be 5 digits',
    ),
  }),
  phoneNumber: string({ required_error: IS_REQUIRED }).refine(validatePhoneNumber, {
    message: IS_VALID,
  }),
  emailAddress: string({ required_error: IS_REQUIRED }).email(),
  monthlyPerformanceGoal: preprocess(
    (val) => val ?? {},
    object({
      membersPerStore: monthlyPerformanceGoalSchema,
      transactionsPerStore: monthlyPerformanceGoalSchema,
    }),
  ),
});

export const validateRetailerNetworkConfiguration = makeValidate(
  retailerNetworkConfigurationSchema,
);
